import {chain}     from "../../utils/fs";
import {isApiTrue} from "../is-api-true";

export const getCountryCode = ({templateOptions}) => {
    return chain(
        templateOptions?.options.find((o) => o.group === "OPTIONS" && o.devKey === "enable_canada_mailing"),
        (o) => isApiTrue(o?.value),
        (_) => _ ? "CA" : "US",
    );
};
